import { Component, Vue, Watch } from 'vue-property-decorator';
import template from './current-subscription.vue';
import apiService from '@/services/api.service';
import { Action } from '@/store';
import { ModalState, ModalComponents, Subscription } from '@/definitions';
import { nl, enUS } from 'date-fns/locale';
import { LocalUser } from '@/store/store.definitions';
import { readableDate, moneySeperator } from '@/utilities';

@Component({
  mixins: [template],
})
export default class CurrentSubscription extends Vue {
  subscriptions: Subscription[] = [];
  userAmount: number = 0;

  @Watch('$store.state.modal.active')
  async modalStateChange(active: boolean) {
    if (!active) {
      this.subscriptions = await apiService.getSubscription(this.$i18n.locale === 'nl' ? nl : enUS);
    }
  }

  async created() {
    if (this.user.isAdmin) {
      const users = await apiService.getUsers();
      this.userAmount = users.length;
      try {
        this.subscriptions = await apiService.getSubscription(this.$i18n.locale === 'nl' ? nl : enUS);
      } catch (e) {
        this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.payments.retrieve_error', type: 'danger' });
      }
    }
  }

  get user(): LocalUser {
    return this.$Store.state.user;
  }

  get activeSubs(): boolean {
    return !!this.subscriptions.filter(s => s.status === 'active').length;
  }

  getReadableDate(date: string): string {
    return readableDate(new Date(date), this.$i18n.locale === 'nl' ? nl : enUS, 'PP');
  }

  getMoneyString(amount: number): string {
    return `€ ${moneySeperator(amount.toString(), this.$i18n.locale)}`;
  }

  async cancelSubscription(id: string) {
    const modalData = {
      component: ModalComponents.CANCEL_SUBSCRIPTION,
      props: { subId: id }
    };
    this.$Store.dispatch(Action.SHOW_MODAL, modalData);
  }

  async changeSubscription() {
    const modalState: ModalState = {
      component: ModalComponents.CHANGE_SUBSCRIPTION,
      active: true,
      props: {
        subscriptions: this.subscriptions
      }
    }
    this.$Store.dispatch(Action.SHOW_MODAL, modalState);
  }
}